module.exports = __webpack_public_path__ + "static/media/video_thumb2.e58b7d2b.png";